export default __webpack_public_path__ + "static/media/FoodChainCity_09.bc91aa58.png";